import shared from "emun.products/product.config.es6"

export default Object.assign({}, shared, {
  filters: [
        { tag: "Vendor"},
        { tag: "Category" },
        { tag: "SubCategory" },
        {
            number: "WholesalePrice",
            title: "Price",
            min: 0,
            max: 2000,
            step: 0.01
        },
        {
            number: "MinimumOrderQty",
            title: "Minimum Qty",
            min: 0,
            max: 2000,
            step: 1
        },
        { groupBy: "Status", authorize: s => s.isCorpOrAbove() },
        { date: "CreatedOn", title: "Created Date" }
    ],
	hotspotDefaultOutlineOn: true,
    productExportTemplate: "ProductGridExport",
    productExportOrigin: "A2",
    productExportFilename: "ProductGridExport.xlsx",
    productParserIdIn: true,
    hideListExpiresOn: true,
    listDaysExpire: 365,
    fields: "VendorId,Id,ManufacturerNumber,ShortDescription,LongDescription,Price,MinimumOrderQty,PurchaseIncrement,UpcCode,UOM,ShipOn,AvailableOn,AvailableQty,CategoryId,SubCategory,Status,IsSellable"
});
